import axios from 'axios';
import { endPoint } from '../utils/Utils';

export async function createSalerPerformance(pointId, userId, rating, comment) {
    const data = { "user_id": userId, "rate": rating, "comment": comment }
    await axios.patch(`${endPoint}/saler-performance/userEvaluate/${pointId}`, data).then((response) => response.data);
}